'use es6';

import { syntheticEvent } from 'foundations-components/transitional/utils/SyntheticEvent';
import { callIfPossible } from 'foundations-components/transitional/utils/functions';
import { computeCurrentView } from './DrilldownSelect.helpers';
export const createHandlers = component => ({
  handleChange: option => {
    // react-select-plus gives us an option object or null, which we pass to
    // onSelectedOptionChange, but our onChange handler expects just the new value.
    const {
      onOpenChange,
      onChange,
      onSelectedOptionChange
    } = component.props;
    const {
      value
    } = component.state;
    callIfPossible(onSelectedOptionChange, syntheticEvent(option));
    let newVal = null;
    if (Array.isArray(option)) {
      newVal = option.reduce((acc, item) => {
        if (item) {
          const {
            value: itemValue
          } = item;
          const i = acc.indexOf(itemValue);
          if (i > -1) {
            acc.splice(i, 1);
          } else {
            acc.push(itemValue);
          }
        }
        return acc;
      }, []);
    } else if (option) {
      newVal = option.value;
    }
    if (option.children) {
      onOpenChange(syntheticEvent(true));
      const {
        optionsStack
      } = component.state;
      component.setState({
        optionsStack: [...optionsStack, option.children]
      });
    } else {
      onOpenChange(syntheticEvent(false));
      if (newVal !== value) {
        component.setState({
          value: newVal
        });
        onChange(syntheticEvent(option));
      }
    }
  },
  handleInputKeyDown: evt => {
    const {
      onInputKeyDown
    } = component.props;
    callIfPossible(onInputKeyDown, evt);
    if (evt.defaultPrevented) {
      return;
    }
  },
  triggerOpen: () => {
    const {
      onOpenChange
    } = component.props;
    onOpenChange(syntheticEvent(true));
  },
  handleOpenChange: evt => {
    const {
      onOpenChange
    } = component.props;
    callIfPossible(onOpenChange, evt);
  },
  handleInputChange: str => {
    const {
      onInputChange
    } = component.props;
    callIfPossible(onInputChange, str);
    component.setState({
      inputValue: str
    });
    return str;
  },
  handleInputValueChange: evt => {
    const {
      onInputValueChange
    } = component.props;
    callIfPossible(onInputValueChange, evt);
    component.setState(Object.assign({
      inputValue: evt.target.value
    }, computeCurrentView(component.props, component.state, {
      inputValue: evt.target.value
    })));
  },
  handleAutosize: () => {
    if (component.popoverRef.current) component.popoverRef.current.reposition();
  }
});